import React, { useState } from "react";
import RenderButton from "../common/button";

const Headder = ({ onChange, disabled }) => {
  // console.log(groupid)

  const [select, setselect] = useState("btn btn-primary");
  const [receive, setreceive] = useState("btn btn-outline-dark");
  const [performance, setperformance] = useState("btn btn-outline-dark");

  const handleonClick = ({ currentTarget: input }) => {
    if (input.value == 0) {
      disabledlabel();
      setselect("btn btn-primary");
    } else if (input.value == 1) {
      disabledlabel();
      setreceive("btn btn-primary");
    } else if (input.value == 2) {
      disabledlabel();
      setperformance("btn btn-primary");
    }
    onChange(input.value);
  };
  // const handleChange = (date) => {
  //     setStartDate(date)
  //     handleDateChange(date);
  // }

  const disabledlabel = () => {
    setselect("btn btn-outline-dark");
    setreceive("btn btn-outline-dark");
    setperformance("btn btn-outline-dark");

    // setCBD('btn btn-outline-dark') ;
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-auto mb-1 px-0 ">
          <RenderButton
         
            value="0"
            label="เลือกรายงาน"
            onClick={handleonClick}
            className={select}
          />
          <RenderButton
           disabled = {disabled}
            value="1"
            label="ไม้ท่อนรับเข้า"
            onClick={handleonClick}
            className={receive}
          />
          <RenderButton
           disabled = {disabled}
            value="2"
            label="ผลผลิต"
            onClick={handleonClick}
            className={performance}
          />
        </div>
      </div>
    </div>
  );
};

export default Headder;
